/**
 * PAYMENT_MODE — the one switch of the payment flow.
 *
 *   'disabled'  (now) PAYUNi is not approved: the flow keeps every state
 *               (QUOTE_CONFIRMED → PAYMENT_PENDING → PAYMENT_CONFIRMED) but the
 *               DisabledPaymentProvider passes them at once, marked as a bypass.
 *   'test'      PAYUNi sandbox via the Worker — not implemented, refused at startup.
 *   'live'      PAYUNi production via the Worker — not implemented, refused at startup.
 *
 * Deliberately a literal, not an environment variable: nobody can flip a
 * production build to a mode whose provider does not exist, and 'disabled' can
 * never be reached by a misspelt variable. When live mode exists, read it here
 * with parsePaymentMode(import.meta.env.VITE_PAYMENT_MODE) and nowhere else.
 */

import { parsePaymentMode, type PaymentMode } from './types';

export const PAYMENT_MODE: PaymentMode = parsePaymentMode('disabled');

/** Prefix of the local temporary order ids of disabled mode. */
export const DISABLED_ORDER_ID_PREFIX = 'dev_';
